var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#1B1F23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29326 7.74374C4.43021 6.03797 5.70319 4.65252 7.35497 4.34474C6.63638 5.33744 6.20929 6.5151 6.12729 7.74374H4.29326ZM11.8062 8.35534C11.6692 10.0611 10.3962 11.4465 8.74451 11.7543C9.46304 10.7616 9.89017 9.58394 9.97217 8.35534H11.8062ZM6.12729 8.35534C6.20929 9.58394 6.63638 10.7616 7.35497 11.7543C5.70319 11.4465 4.4302 10.0611 4.29326 8.35534H6.12729ZM9.97217 7.74374C9.89017 6.5151 9.46304 5.33744 8.74451 4.34474C10.3962 4.65252 11.6692 6.03797 11.8062 7.74374H9.97217ZM8.04971 3.66925C5.63055 3.66925 3.66943 5.63037 3.66943 8.04954C3.66943 10.4687 5.63055 12.4298 8.04971 12.4298C10.4689 12.4298 12.43 10.4687 12.43 8.04954C12.43 5.63037 10.4689 3.66925 8.04971 3.66925ZM9.35904 7.74374H6.74037C6.82937 6.53556 7.28657 5.38361 8.04971 4.44344C8.81284 5.38362 9.27004 6.53556 9.35904 7.74374ZM8.04971 11.6556C7.28657 10.7155 6.82937 9.56348 6.74037 8.35534H9.35904C9.27004 9.56348 8.81284 10.7155 8.04971 11.6556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCircle);
export default __webpack_public_path__ + "static/media/webCircle.c78dd23adf499f4e1b7458b4f98221b3.svg";
export { ForwardRef as ReactComponent };